import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printSuccess } from '../../output.js'

export const servicesUpdateCommand = new Command(`update`)
  .usage(`<id> --name <name>`)
  .description(`Update a service`)
  .argument(`<id>`, `Service ID`)
  .requiredOption(`--name <name>`, `New service name`)
  .action(async (serviceId: string, opts) => {
    const json = servicesUpdateCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.services.update({
        serviceId,
        name: opts.name,
      })

      if (isQuiet()) {
        printQuiet(serviceId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Service ${serviceId} updated.`)
      }
    } catch (error) {
      handleError(error, json)
    }
  })
